/* eslint-disable @typescript-eslint/naming-convention */
import { useState } from 'react'
import { ThemeProvider } from 'styled-components'
import { CategoryIds } from '../CategoryTabs'
import {
  NavHeading,
  NavigationContainer,
  NavList,
  NavListItem,
  ProgressBarContainer,
  ProgressBarFiller,
  ServiceHeader,
  ServiceInfo,
  PTContainer,
  WidgetContainer,
} from './styles'
import { DS, componentsMap, iconsMap } from './config'

export type Service = {
  id: string
  title: string
  defaultActive: boolean
  progress: number
  icon: string
  component: string
  theme: {
    primary: string
    base: string
    soft: string
    muted: string
    text: string
    badge: string
  }
}

export function useProgressTracker(cateogryId: CategoryIds) {
  const data = DS[cateogryId]
  const [activeServiceId, setActiveServiceId] = useState(data[0].id)
  const selectedService = data.find(service => service.id === activeServiceId)

  return {
    data,
    activeServiceId,
    setActiveServiceId,
    selectedService: selectedService || data[0],
  }
}

export function ProgressTracker({ categoryId }: { categoryId: CategoryIds }) {
  const { data, activeServiceId, setActiveServiceId, selectedService } =
    useProgressTracker(categoryId)

  const Widget = componentsMap[selectedService?.component ?? '_'] ?? componentsMap._

  return (
    <PTContainer>
      <NavigationContainer>
        <NavHeading>PROGRESS</NavHeading>
        <NavList>
          {data.map(service => {
            const isActive = activeServiceId === service.id
            const Icon = iconsMap[service?.icon ?? '_']

            return (
              <ThemeProvider key={service.id} theme={service.theme}>
                <NavListItem isActive={isActive} onClick={() => setActiveServiceId(service.id)}>
                  <Icon alt={service.title} />
                  <ServiceInfo>
                    <ServiceHeader>
                      <span>{service.title}</span>
                      <span>{service.progress}%</span>
                    </ServiceHeader>
                    <ProgressBarContainer isActive={isActive}>
                      <ProgressBarFiller progress={service.progress} />
                    </ProgressBarContainer>
                  </ServiceInfo>
                </NavListItem>
              </ThemeProvider>
            )
          })}
        </NavList>
      </NavigationContainer>

      <WidgetContainer>
        <Widget service={selectedService} />
      </WidgetContainer>
    </PTContainer>
  )
}
